import { c as _c } from "react/compiler-runtime";
import { type ComponentProps } from 'react';
export const IframeIcon = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path fillRule="evenodd" clipRule="evenodd" d="M13.0896 3.68556L13.385 2.9962L12.0063 2.40532L11.7109 3.09468L6.90155 14.3164L6.60611 15.0058L7.98483 15.5967L8.28027 14.9073L13.0896 3.68556ZM6.60011 5.79426L5.893 6.50136L3.39389 9.00047L5.893 11.4996L6.60011 12.2067L5.1859 13.6209L4.47879 12.9138L1.27257 9.70758L0.565465 9.00047L1.27257 8.29337L4.47879 5.08715L5.1859 4.38004L6.60011 5.79426ZM13.3902 12.2066L14.0973 11.4995L16.5964 9.00036L14.0973 6.50125L13.3902 5.79414L14.8044 4.37993L15.5115 5.08703L18.7177 8.29325L19.4248 9.00036L18.7177 9.70747L15.5115 12.9137L14.8044 13.6208L13.3902 12.2066Z" fill="currentColor" style={{
      fill: "currentColor"
    }} />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>{t0}</svg>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};